<div class="overview-main-wrapper">
  <div  *ngIf="customerDetails" class="content">
    <h2>
      {{ customerDetails?.firstName + " " + customerDetails?.lastName }}
    </h2>
    <h4>
      <img src="assets/images/icons/icon-mail.svg" alt="Icon Mail" />
      {{ customerDetails?.email }}
    </h4>
  </div>
  <div  *ngIf="customerDetails" class="client-details-overview-wrapper">
    <div class="details-wrapper">
      <h2>Phone Number</h2>
      <h3>{{ customerDetails?.phoneNumber }}</h3>
    </div>
    <div class="details-wrapper">
      <h2>Addresss</h2>
      <h3>{{ customerDetails?.address }}</h3>
    </div>
    <div class="details-wrapper">
      <h2>City</h2>
      <h3>{{ customerDetails?.city }}</h3>
    </div>
    <div class="details-wrapper">
      <h2>State</h2>
      <h3>{{ customerDetails?.state }}</h3>
    </div>
    <div class="details-wrapper">
      <h2>Country</h2>
      <h3>{{ customerDetails?.country }}</h3>
    </div>
    <div class="details-wrapper">
      <h2>ZIP Code</h2>
      <h3>{{ customerDetails?.zipCode }}</h3>
    </div>
  </div>
</div>
